import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { MatDialog } from "@angular/material/dialog";
import { ContratistaService } from 'src/app/services/contratista.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { ZonaService } from 'src/app/services/zona.service';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-nuevo-usuario',
  templateUrl: './nuevo-usuario.component.html',
  styleUrls: ['./nuevo-usuario.component.scss']
})
export class NuevoUsuarioComponent implements OnInit {

  isLinear = false;
  datosUser: any={};
  public username: any
  public fullName: any
  public email: any
  private password: any
  public isInproeco: boolean
  public isCliente: boolean
  public isContratista: boolean
  public isChecked: boolean
  public contratistas: Array<any>
  public contratista: any
  public clientes: Array<any>
  public cliente: any
  public zonas: Array<any>
  public grupos: Array<any>
  public isAdmin: boolean
  public isUser: boolean
  public rol: any


  constructor(private formBuilder: FormBuilder, private apollo: Apollo, private usuariosService: UsuariosService, public dialog: MatDialog, private contratistaService: ContratistaService, private clienteService: ClienteService, private zonaService: ZonaService, private emailService: EmailService) {
    this.buildForm();
    this.isInproeco = false
    this.isCliente = false
    this.isContratista = false
    this.isChecked = false
    this.contratistas = []
    this.clientes = []
    this.zonas = []
    this.grupos = []
    this.isAdmin = false
    this.isUser = false
    
  }

  ngOnInit(): void {
  }

  private buildForm(){
    this.datosUser = this.formBuilder.group({
      /* name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      email: ['', [Validators.required,Validators.email]],
      password: ['', [Validators.required]],
      cliente: [''],
      contratista: [''] */
      name: [''],
      surname: [''],
      email: [''],
      cliente: [''],
      zonas: [''],
      grupos: [''],
      contratista: [''],
      rol: ['']
    });
  }
  
  setUser(){
    this.username = this.datosUser.value.email
    this.fullName = `${this.datosUser.value.name} ${this.datosUser.value.surname}` 
    this.email = this.datosUser.value.email
    this.cliente = this.datosUser.value.cliente
    this.contratista = this.datosUser.value.contratista
    this.zonas = this.datosUser.value.zonas
    this.grupos = this.datosUser.value.grupos
    this.rol = this.isAdmin ? 'admin' : 'user'
  }

  checkUserType(){
    if(this.isInproeco){
      this.addUsuarioInproeco()
    }
    else if(this.isCliente){
      this.addUsuarioCliente()
    }
    else if(this.isContratista){
      this.addUsuarioContratista()
    }
  }

  saveUser(){
    this.checkUserType()
  }

  addUsuarioInproeco() {
    this.setUser()
    const password = this.generatePassword()
    console.log(this.isInproeco)
    this.apollo.mutate<any>({
      mutation: this.usuariosService.addUser(),
      variables: {
        "input": {
          "data": {
            "username": this.username,
            "name": this.fullName,
            "email": this.email,
            "password": password,
            "inproeco": this.isInproeco,
            "rol": this.rol
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      if(data){
        this.confirmUser(data.createUser.user.id)
        const templateUsuario = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/bienvenidaxtensa_df33d6a1cd.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Bienvenido ${this.fullName}, ha sido dado de alta en XTENSA</h1>
        <div style=" font-size: 1.2rem">
        <p>Este es su nombre de usuario: ${this.email}</p>
        <p>Esta es su contraseña: ${password}</p>
        </div>
        </div>
        <div style="text-align:center; margin-top:50px">
        <a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px; margin-right:140px; ">+ INFO</a><a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px;">ACEPTAR</a>
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>

        </html>`;


            this.emailService.send(
              this.email,
              'Alta nueva Xtensa',
              templateUsuario
            );
      }
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  addUsuarioCliente() {
    this.setUser()
    const password = this.generatePassword()
    console.log('aaaa',this.zonas, this.grupos)
    this.apollo.mutate<any>({
      mutation: this.usuariosService.addUser(),
      variables: {
        "input": {
          "data": {
            "username": this.username,
            "name": this.fullName,
            "email": this.email,
            "password": password,
            "cliente": this.cliente,
            "zonas": this.zonas,
            "agrupacions": this.grupos,
            "rol": this.rol
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      if(data){
        this.confirmUser(data.createUser.user.id)
        const templateUsuario = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/bienvenidaxtensa_df33d6a1cd.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Bienvenido ${this.fullName}, ha sido dado de alta en XTENSA</h1>
        <div style=" font-size: 1.2rem">

        <p>Este es su nombre de usuario: ${this.email}</p>
        <p>Esta es su contraseña: ${password}</p>
        </div>
        </div>
        <div style="text-align:center; margin-top:50px">
        <a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px; margin-right:140px; ">+ INFO</a><a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px;">ACEPTAR</a>
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>

        </html>`;


            this.emailService.send(
              this.email,
              'Alta nueva Xtensa',
              templateUsuario
            );
      }
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  addUsuarioContratista() {
    this.setUser()
    const password = this.generatePassword()
    this.apollo.mutate<any>({
      mutation: this.usuariosService.addUser(),
      variables: {
        "input": {
          "data": {
            "username": this.username,
            "name": this.fullName,
            "email": this.email,
            "password": password,
            "contratista": this.contratista,
            "rol": this.rol
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      if(data){
        console.log(data.createUser.user.id)
        this.confirmUser(data.createUser.user.id)
        const templateUsuario = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/bienvenidaxtensa_df33d6a1cd.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Bienvenido ${this.fullName}, ha sido dado de alta en XTENSA</h1>
        <div style=" font-size: 1.2rem">
        <p>Este es su nombre de usuario: ${this.email}</p>
        <p>Esta es su contraseña: ${password}</p>
        </div>
        </div>
        <div style="text-align:center; margin-top:50px">
        <a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px; margin-right:140px; ">+ INFO</a><a href="http:/localhost:4200" style="text-decoration: none; background-color: #1f775a; color: white; font-weight: bolder; width: fit-content; padding: 7px 30px 5px 29px; border-radius: 25px;">ACEPTAR</a>
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>

        </html>`;


            this.emailService.send(
              this.email,
              'Alta nueva Xtensa',
              templateUsuario
            );
      }
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  onCheckedInproeco(e: any){
    this.isCliente = false
    this.isContratista = false
    this.isInproeco = !this.isInproeco
  }

  onCheckedCliente(e: any){
    this.isCliente = !this.isCliente
    this.isContratista = false
    this.isInproeco = false
    this.getClientes()
  }

  onChangeCliente(){
    this.getZonasByCliente()
    this.getGruposByCliente()
  }

  onCheckedContratista(e: any){
    this.isCliente = false
    this.isInproeco = false
    this.isContratista = !this.isContratista
    this.getContratistas()
  }

  getContratistas(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistasName(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        data.contratistas.map((contratista: any) => {
          if(contratista.nombreComercial){
            this.contratistas.push(contratista)
          }
        })
      })
  }

  getClientes(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientesName(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        data.clientes.map((cliente: any) => {
          if(cliente.nombreComercial){
            this.clientes.push(cliente)
          }
        })
      })
  }

  getZonasByCliente(){
    this.apollo.watchQuery<any>({
      query: this.zonaService.getZonasByCliente(),
      variables:{
        id: this.datosUser.value.cliente
      }
    })
    .valueChanges
    .subscribe(({data}) => {
      console.log(data)
      this.zonas = data.cliente.zonas
    })
  }

  getGruposByCliente(){
    this.apollo.watchQuery<any>({
      query: this.zonaService.getGruposByCliente(),
      variables:{
        id: this.datosUser.value.cliente
      }
    })
    .valueChanges
    .subscribe(({data}) => {
      console.log(data)
      this.grupos = data.cliente.agrupacions
    })
  }

  onCheckedAdmin(e: any){
    this.isUser = false
    this.isAdmin = !this.isAdmin
  }

  onCheckedUser(e: any){
    this.isAdmin = false
    this.isUser = !this.isUser
  }

  confirmUser(id: string){
    console.log(id)
    this.apollo.mutate({
      mutation: this.usuariosService.updateUsuario(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "confirmed": true
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  generatePassword() {
    let length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
  
}
